const model = {
  name: {
    name: "название",
    sex: 1,
    required: true,
    checkLength: false
  },
  city: {
    name: "местоположение",
    sex: 0,
    required: true,
    checkLength: false
  },
  work_days: {
    name: "Рабочие дни",
    sex: 0,
    required: true,
    checkLength: false
  },
  cash_desk: {
    name: "Касса на конец дня",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  },
  cash_desk_start_day: {
    name: "Касса на начало дня",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  },
  count_fine_days: {
    name: "Количество дней штрафа",
    sex: 1,
    required: true,
    checkLength: false,
    isNumber: true
  },
  percent_fine: {
    name: "Процент штрафа за задержку",
    sex: 1,
    required: true,
    checkLength: false,
    isNumber: true
  },
  sum_fine_bilet_out: {
    name: "Штраф за потерю билета",
    sex: 1,
    required: true,
    checkLength: false,
    isNumber: true
  },
  money: {
    sum: {
      name: "сумма",
      sex: 2,
      required: true,
      checkLength: false,
      isNumber: true
    },
    created_at: {
      name: "Дата операции",
      sex: 2,
      required: true,
      checkLength: true,
      min: 10,
      max: 10,
      isNumber: false
    }
  },
  percents: {
    priority: {
      name: "Приоритет",
      sex: 1,
      required: true,
      checkLength: false,
      isNumber: true,
      isNumberInteger: true
    },
    condition: {
      name: "условие",
      sex: 0,
      required: true,
      checkLength: false
    },
    form: {
      name: "Источник",
      sex: 1,
      required: true,
      checkLength: false
    },
    target: {
      name: "Цель",
      sex: 2,
      required: true,
      checkLength: false,
      isNumber: true
    },
    percent: {
      name: "Процент",
      sex: 1,
      required: true,
      checkLength: false,
      isNumber: true
    }
  },
  prices: {
    price_new: {
      name: "Стоимость нового",
      sex: 2,
      required: true,
      checkLength: false,
      isNumber: true,
      isNumberInteger: true
    },
    price_normal: {
      name: "Стоимость нормального",
      sex: 2,
      required: true,
      checkLength: false,
      isNumber: true,
      isNumberInteger: true
    },
    price_crack: {
      name: "Стоимость лома",
      sex: 2,
      required: true,
      checkLength: false,
      isNumber: true,
      isNumberInteger: true
    }
  }
};

module.exports = model;
